import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=0b21cc56&scoped=true&"
import script from "./RouteView.vue?vue&type=script&lang=js&"
export * from "./RouteView.vue?vue&type=script&lang=js&"
import style0 from "./RouteView.vue?vue&type=style&index=0&id=0b21cc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21cc56",
  null
  
)

export default component.exports